export function groupGrades(assignedSections) {
  const grades = {
    Nursery: [],
    NURSERY: [],
    LKG: [],
    UKG: [],
    I: [],
    II: [],
    III: [],
    IV: [],
    V: [],
    VI: [],
    VII: [],
    VIII: [],
    IX: [],
    X: [],
    XI: [],
    XII: [],
  };
  assignedSections.forEach((section) => {
    if (!grades[section.grade]) {
      grades[section.grade] = [];
    }
    grades[section.grade].push(section);
  });

  Object.keys(grades).forEach((key) => {
    if (!grades[key].length) delete grades[key];
  });

  return grades;
}

export function groupGradeSections(sections) {
  const grades = {};
  sections.forEach((section) => {
    const [grade, sec] = section.split("-");
    if (!grades[grade]) {
      grades[grade] = [];
    }
    grades[grade].push(sec);
  });
  return grades;
}
